export default __webpack_public_path__ + "static/media/menu.3fe1eac6.svg";